/**
 * Assert that a condition is true, and throw an error if it's not.
 *
 * This is also a useful way to persuade TypeScript that a condition is true
 * at the type level. For instance, if you have an optional value that you know
 * based on other checks must be defined, you can use `assert` to convince the
 * TypeScript compiler of that. For instance:
 *
 *     // Given state: WebRecorder2State
 *     if (['paused', 'recording'].includes(state.mode)) {
 *       // Note that as of v5.7.2, tsc is not smart enough to deduce that within
 *       // this block, state.mode must be 'paused' or 'recording', so we use `assert`
 *       // to convince it.
 *       assert(state.mode === 'paused' || state.mode === 'recording', 'Must have a recorder')
 *       state.recorder.start()
 *     }
 */
export function assert<T>(condition: T, message: string): asserts condition {
  if (!condition) {
    /* eslint-disable-next-line no-console */
    console.error(message)
    throw new Error(message)
  }
}
